import React from 'react'
import CustomCursor from '../../Global/Cursor'
import Preloader from '../../Global/Preloader'
import Header from '../../Global/Header2'
import Banner from '../MenHomeTwo/Banner'
import Partner from '../MenHomeTwo/Partner'
import About from '../MenHomeTwo/About'
import Service from '../MenHomeTwo/Service'
import Testimonial from '../MenHomeTwo/Testimonial'
import WhyChouse from '../MenHomeTwo/WhyChouse'
import Work from '../MenHomeTwo/Work'
import Process from '../MenHomeTwo/Process'
import Portfilo from '../MenHomeTwo/Portfilo'
import Blog from '../MenHomeTwo/Blog'
import Cta from '../MenHomeTwo/Cta'
import Footer2 from '../../Global/Footer2'
import BackToTop from '../../Global/GoToTop'

const Main = () => {
    return (
        <>
            <CustomCursor />
            <Preloader />
            <Header />
            <Banner />
            <Partner />
            <About />
            <Service />
            <Testimonial />
            <WhyChouse />
            <Work />
            <Process />
            <Portfilo />
            <Blog />
            <Cta />
            <Footer2 />
            <BackToTop />
        </>
    )
}

export default Main
